/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Audio_Description_Export_Event_Needs_RenderInputs */

const en_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const fr_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const de_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const it_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const ru_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const es_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const zh_cn2_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const ja_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const hi_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

const pt_pt2_audio_description_export_event_needs_render = /** @type {(inputs: Audio_Description_Export_Event_Needs_RenderInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Event ${i?.index} needs to be rendered. The saved audio does not match the current text or voice.
 Would you like to ABORT your export?`)
};

/**
* | output |
* | --- |
* | "Event {index} needs to be rendered. The saved audio does not match the current text or voice. Would you like to ABORT your export?" |
*
* @param {Audio_Description_Export_Event_Needs_RenderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_event_needs_render = /** @type {((inputs: Audio_Description_Export_Event_Needs_RenderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Event_Needs_RenderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_event_needs_render(inputs)
	if (locale === "de") return de_audio_description_export_event_needs_render(inputs)
	if (locale === "it") return it_audio_description_export_event_needs_render(inputs)
	if (locale === "ru") return ru_audio_description_export_event_needs_render(inputs)
	if (locale === "es") return es_audio_description_export_event_needs_render(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_event_needs_render(inputs)
	if (locale === "ja") return ja_audio_description_export_event_needs_render(inputs)
	if (locale === "hi") return hi_audio_description_export_event_needs_render(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_event_needs_render(inputs)
	return en_audio_description_export_event_needs_render(inputs)
});